import React from 'react';

import Box from '../../../components/basic/box'
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'
import CustomSnackbar from '../../../components/global/snackbar'

import Logo from '../../../components/basic/logo'
import queryString from 'query-string'
import {api} from '../../../functions/api'


import { inject } from 'mobx-react';

import {
    CircularProgress
} from '@material-ui/core';

@inject('internal')
@inject('translate')
export default class ResetPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openSnackbar:false,
            message: "",
            email: null,
            access_token: queryString.parse(props.history.location.search).token,
            tokenIsValid: false,
            messageError: "",
            loadingBtn: false,
        }
    }

    componentDidMount() {
        //7132bff5e578b0e41f3c522a7879274151696f3f182b159830da97f27c146998
        this.getUrl();
    }

    getUrl = async () => {
        this.setState({loading: true})
        let load_data = await api({
            method:'get',
            url:'password/reset/'+this.state.access_token,
        })
    
        if(load_data.success === true) {
            this.setState({tokenIsValid: true, email: load_data.data.data.email})
        }
        else if(load_data.success === false) {
            this.setState({tokenIsValid: false, messageError: load_data.data.message})
            // this.props.internal.setSnackbar(load_data.data.message, true)
        }
        this.setState({loading: false})
    }

    resetPassword = async (pass1, pass2) => {

        let load_data = await api({
            method:'post',
            url:'password/reset',
            params: {
                token: this.state.access_token,
                email: this.state.email,
                password: pass1,
                password_confirmation: pass2,
            }
        })

        if(load_data.success === true) {
            this.navigateTo('/')
            this.props.internal.setSnackbar(load_data.data.message, true)
            
        }
        else {
            this.props.internal.setSnackbar(load_data.data.message, true)
        }
        this.setState({loadingBtn:false})
    }

    handleResetButton = () => {
        this.setState({loadingBtn: true})
        let input1 = this.inputPassword.state.value;
        let input2 = this.inputPassword2.state.value;
        
        if(input1 === input2 && input1.length > 7) {
            // this.setState({loading: true})
            this.resetPassword(input1, input2);
        }
        else {
            if(input1 !== input2) {
                this.props.internal.setSnackbar( this.props.translate.i18n.GLOBAL.ALERTS.DIFFERENT_PASSWORDS, true)
                // this.setState({message: this.props.translate.i18n.GLOBAL.ALERTS.DIFFERENT_PASSWORDS, openSnackbar: true})
            }
            else {
                this.props.internal.setSnackbar( this.props.translate.i18n.GLOBAL.ALERTS.IS_NOT_MIN_LENGTH, true)
            }
            this.setState({loadingBtn: false})
        }
    }

    navigateTo = (data) => {
        if(data) {
            this.props.history.push(data);
        }
        else {
            this.props.history.push('/');
        };
    }

    handleCloseSnackbar = () => {
        this.setState({ openSnackbar: false });
    };

    render() {
       // this.getUrl();
        return (

            <div className={'container-with-logo'}>
            <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} onClose={this.handleCloseSnackbar}/>
                <Logo/>
                {this.state.loading ?
                <CircularProgress className={'circular-progress'} />
                :
                null
                }
                {this.state.tokenIsValid ?
                <Box>
                    <h5>{this.props.translate.i18n.LOGIN.RESET_PASSWORD_TITLE}</h5>
                    <CustomInput
                      //regex={regexes.email}
                        ref={ref => this.inputPassword = ref}
                        type={'password'}
                        text={this.props.translate.i18n.LOGIN.SET_NEW_PASSWORD}
                        id={'password-1'}
                        // onChange={(data) => this.handleChange(data, "email")}
                        //isValid={this.state.emailIsOk}
                    />
                    <CustomInput
                      //regex={regexes.email}
                        ref={ref => this.inputPassword2 = ref}
                        type={'password'}
                        text={this.props.translate.i18n.LOGIN.REPEAT_NEW_PASSWORD}
                        id={'password-2'}
                        // onChange={(data) => this.handleChange(data, "email")}
                        //isValid={this.state.emailIsOk}
                    />
                    <div className={'buttons'}>
                        <CustomButton
                            onClick={() => this.navigateTo('/')}
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.LOGIN.BACK_TO_LOGIN}
                            justText
                        />
                        <CustomButton
                            progressBar={this.state.loadingBtn}
                            onClick={this.handleResetButton}
                            mystyle={'btn-orange-bg'}
                            title={this.props.translate.i18n.LOGIN.RESET_PASSWORD}
                            justText
                            pressButton
                        />
                    </div>
                </Box>
                :
                this.state.messageError !== "" ?
                    <div >
                        <span>{this.state.messageError}</span>
                        <br/>
                        <a href="/reset" className={'orage-text text-center'}>{this.props.translate.i18n.LOGIN.RESET_PASSWORD_TITLE}</a>
                    </div>
                    :
                null
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/reset/resetPassword/index.js